import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import PageTopTitle from '../../components/shared/PageTopTitle'
import Button from '../../components/shared/button/Btn'
import { useState } from 'react'
import { showModal } from '../../features/modal/modalSlice'
import { useEffect } from 'react'
import { getKayitliYukler } from '../../features/kayit/kayitSlice'
import { clearAddressData, getAllRegisteredAddressList } from '../../features/registeredAddress/registeredAddressSlice'
import KayitliAdreslerContainer from '../../components/adresYonetimiContainers/KayitliAdreslerContainer'
import KayitliYuklerContainer from '../../components/adresYonetimiContainers/KayitliYuklerContainer'
import useWindowDimensions from "../../hooks/useWindowSize"
import KayitliAdreslerContainerMobile from '../../components/adresYonetimiContainers/KayitliAdreslerContainerMobile'
import KayitliYuklerContainerMobile from '../../components/adresYonetimiContainers/KayitliYuklerContainerMobile'
import { resetAddLoadState } from '../../features/addLoad/addLoadSlice'
const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
        margin: 40px 30px;
        display: flex;
        width: calc(100% - 60px);
        padding-bottom: 5px;
        flex-direction: column;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        .table{
          margin-top: 20px;
        }
        .titles-yuk {
          width: 95%;
          gap: 15px;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-inline: 15px;
          color: ${({ theme }) => theme.mainTextColor};
          p{
            width: 130px;
            text-align: center;
          }
        }
        .titles-adres {
          width: 95%;
          gap: 15px;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          text-align: center;
          display: grid;
          padding-inline: 15px;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          color: ${({ theme }) => theme.mainTextColor};
          
        }

        .btn-container{
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;

            .btn-grp{
                display: flex;
                gap: 20px;
            }
        }

        .main-title{
            padding: 10px;
            background-color: ${({ theme }) => theme.secondaryBgColor};
            border-radius: 10px;
            color: ${({ theme }) => theme.mainTextColor};
            margin-bottom: 10px;
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);

        }
        &::-webkit-scrollbar {
        height: 10px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #9e9b9b;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
    }
}

  @media(max-width: 850px){
    .table{
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 10px !important;
    }

    .btn-grp{
      flex-direction: column;
    }

  }
`

const AdresYonetimi = () => {

  const {yukKayitlari} = useSelector(state => state.kayit)
  const {allRegisteredAddressList: adresKayitlari} = useSelector(state => state.registeredAddress)

  const [selectedItem, setSelectedItem] = useState(null)

  const {windowDimensions} = useWindowDimensions()

  const selectPageTab = (item) => {
    setIsAdresPage(item)
  }

  const selectFromId = (item) => {
    if(selectedItem === item){
      setSelectedItem(null)
    }else{
      setSelectedItem(item)
    }
  }

  const [isAdresPage, setIsAdresPage] = useState("adres")

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllRegisteredAddressList({pagination: 1, selectedIl: "", selectedIlce: ""}))
    dispatch(getKayitliYukler())
  },[dispatch])

  const titlesAdres = ["Adres Adı", "İl", "İlçe", "Adres"]
  const titlesYuk = ["Ön Tanımlı Yük Kaydı Adı", "Gönderilen İl", "Gönderilen İlçe","Gönderilecek İl", "Gönderilecek ilçe", "Araç"]
  return (
        <Container>
      <div className="wrapper">
        <PageTopTitle title={"Adres Yönetimi"} position='sticky'/>
        <div className="content">
            <div className="btn-container">
                <div className="btn-grp">
                    <Button type='button' bgColor={isAdresPage === "adres" ? "#E85446" : "#fff"} color={isAdresPage === "adres" ? "#fff" : "#E85446"} fontSize={windowDimensions.width < 450 ? "12px" : "14px"} handleClick={() => selectPageTab("adres")} padding='0 20px' width='auto' >Kayıtlı Adresler</Button>
                    <Button type='button' bgColor={isAdresPage === "yuk" ? "#E85446" : "#fff"} color={isAdresPage === "yuk" ? "#fff" : "#E85446"} fontSize={windowDimensions.width < 450 ? "12px" : "14px"} handleClick={() => selectPageTab("yuk")} padding='0 20px' width='auto' >Kayıtlı Yükler</Button>
                </div>
                <div className="btn-grp">
                    {isAdresPage === "adres" ?
                      <Button type='button' bgColor={"transparent"} color={"#E85446"} handleClick={()=> {dispatch(clearAddressData()); dispatch(showModal("kayitliAdresEkleYeni"))}} fontSize={windowDimensions.width < 450 ? "12px" : "14px"} padding='0 20px' width='auto'>Ön Tanımlı Adres Ekle</Button>
                      :
                      <Button type='button' bgColor={"transparent"} color={"#E85446"} handleClick={()=> {dispatch(resetAddLoadState()); dispatch(showModal("kayitliYukNewEkle"))}} fontSize={windowDimensions.width < 450 ? "12px" : "14px"} padding='0 20px' width='auto'>Ön Tanımlı Yük Ekle</Button>
                    }
                </div>
            </div>
            <h3 className='main-title'>{isAdresPage === "adres" ? "Ön Tanımlı Adres Kayıtları" : "Ön Tanımlı Yük Kayıtları"}</h3>

            {isAdresPage === "adres" && 
              <div onClick={()=>setSelectedItem(null)} className='table'>
                {windowDimensions.width > 850 ?
                  <>
                    <div className="titles-adres">
                      {titlesAdres.map((item) => (
                        <p key={item}>{item}</p>
                      ))}
                    </div>
                    {adresKayitlari.map((item)=>(
                      <KayitliAdreslerContainer key={item.id} selectFromId={selectFromId} selectedItem={selectedItem} setSelectedItem={setSelectedItem} data={item} />
                    ))}
                  </>
                  :
                  adresKayitlari.map((item)=>(
                    <KayitliAdreslerContainerMobile key={item.id} selectFromId={selectFromId} selectedItem={selectedItem} setSelectedItem={setSelectedItem} data={item} />
                  ))
                }
              </div>
                }

        {isAdresPage !== "adres" && 
          <div onClick={()=>setSelectedItem(null)} className='table'>
            {
            windowDimensions.width > 850 ?
            <>
            <div className="titles-yuk">
              {titlesYuk.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </div>
            {yukKayitlari?.map((item) => (
              <KayitliYuklerContainer key={item.id} data={item} />
            ))}
            </>
            : 
            yukKayitlari?.map((item) => (
              <KayitliYuklerContainerMobile key={item.id} data={item} />
            ))
            }
          </div>
        }


     
        </div>
      </div>
    </Container>
  )
}

export default AdresYonetimi
